import { render, staticRenderFns } from "./RewardGridItem.vue?vue&type=template&id=99c05246&scoped=true&"
import script from "./RewardGridItem.vue?vue&type=script&lang=js&"
export * from "./RewardGridItem.vue?vue&type=script&lang=js&"
import style0 from "./RewardGridItem.vue?vue&type=style&index=0&id=99c05246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c05246",
  null
  
)

export default component.exports